import debounce from 'lodash/debounce';
import { Input } from 'antd';
import React, { useCallback, useMemo } from 'react';

export interface PopoverSelectorSearchProps {
	onSearch?: (value: string) => void;
	placeholder?: string;
}

export const PopoverSelectorSearch: React.FC<PopoverSelectorSearchProps> = ({ onSearch, placeholder }) => {
	const debouncedChange = useMemo(
		() =>
			debounce((event: React.ChangeEvent<HTMLInputElement>) => {
				if (onSearch) {
					onSearch(event.target.value);
				}
			}, 750),
		[ onSearch ]
	);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			e.persist();
			debouncedChange(e);
		},
		[ debouncedChange ]
	);

	return (
		<Input.Search
			allowClear
			className='popover-search'
			enterButton
			onChange={ handleChange }
			placeholder={ placeholder } />
	);
};
